module.exports = __webpack_public_path__ + "media/dogs/dog-with-hearts-eb0738a5.svg";